import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../../i18n';
import BarGraphIcon from '../../../../../icons/BarGraphIcon';
import TileDrawerHeaderLayout from '../../../../shared/TileDrawerHeaderLayout';

const DrawerHeader = () => {
  const { t } = useTranslation([i18nNS.POLL]);

  return <TileDrawerHeaderLayout icon={BarGraphIcon}>{t('bar_graph', { ns: i18nNS.POLL })}</TileDrawerHeaderLayout>;
};

export default DrawerHeader;
